import React, { useEffect, useMemo, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'

import MyScoresMenu from '@components/myScores/MyScoresMenu'
import NFIcon from '@components/shared/NFIcon'
import PageLayout from '@layout/PageLayout'
import { SearchCategory } from '@services/SearchService'
import { useSession } from '@stores/globalData/globalData.store'

import type { SearchConfig } from '@services/SearchService'
import type Session from '@utils/Session'

const HomePage: React.FC = () => {
  const session = useSession()
  const { pathname } = useLocation()

  const [showMenu, setShowMenu] = useState(false)
  const searchConfig = useMemo(() => getSearchConfig(session, pathname), [session, pathname])

  // Hide the menu if the route changes
  useEffect(() => {
    setShowMenu(false)
  }, [pathname])

  return (
    <PageLayout hideFooter searchConfig={searchConfig}>
      <div className="flex h-full flex-row">
        <MyScoresMenu showMobile={showMenu} onMobileHide={() => setShowMenu(false)} />

        <div className="relative flex h-full flex-1 flex-col overflow-y-hidden min-h-0">
          {/* Menu Breadcrumb Button */}
          <MobileBreadcrumb onClick={() => setShowMenu(true)} />

          {/* Page Outlet */}
          <div className="relative flex h-full min-h-0 flex-1 flex-col px-2.5 lg:pr-7 lg:pl-0">
            <Outlet />
          </div>
        </div>
      </div>
    </PageLayout>
  )
}

interface BreadcrumbProps {
  onClick: () => void
}
const MobileBreadcrumb: React.FC<BreadcrumbProps> = ({ onClick }) => {
  const { t } = useTranslation()
  return (
    <div className="inline-block mt-4 lg:hidden">
      <button
        type="button"
        className="font-medium text-md flex flex-row items-center px-2.5"
        onClick={onClick}>
        <NFIcon icon="chevron-left" className="text-xl pt-0.5" />
        <span className="text-base font-medium">{t('content.menu')}</span>
      </button>
    </div>
  )
}

export default HomePage

function getSearchConfig(session: Session, pathname: string): SearchConfig {
  if (['/home', '/home/myScores'].includes(pathname)) {
    if (session.isSite()) {
      return {
        [SearchCategory.YOUR_HOME]: 5,
        [SearchCategory.SCORE]: 1,
        [SearchCategory.GROUP]: 1,
      }
    }
    // otherwise use default
  }
  return {
    [SearchCategory.YOUR_HOME]: 5,
    [SearchCategory.TITLE]: 1,
    [SearchCategory.SCORE]: 1,
  }
}
